import React, {memo, useState} from 'react'
import _ from 'lodash'
import {Button, Form, Grid, Header, List, Message, Segment} from 'semantic-ui-react'
import axios from 'axios'
import {withHelmet, withErrorHandling} from '../../hoc'

const sendEmail = async (email) => {
  return axios.post('/bff/users/send-password-reset-code', {email})
}

const _ForgotPassword = (
  {
    navigate,
    sendEmail
  }
) => {
  const [state, setState] = useState({
    email: '',
    sent: false,
    submitted: false,
    errors: {}
  })

  const validate = ({email, errors = {}}) => {
    if (!email) {
      errors['send.email.required'] = 'Email required'
    } else {
      delete errors['send.email.required']
      if (email.length > 255) {
        errors['send.email.exceeds.max.length'] = 'Email cannot exceed 255 characters'
      } else {
        delete errors['send.email.exceeds.max.length']
      }
    }
    return errors
  }

  const onInputChange = (e) => {
    let updatedState = {...state, ...{[e.target.name]: e.target.value}}
    let errors = {}
    if (state.submitted) {
      errors = validate(updatedState)
      updatedState = {...updatedState, ...{errors}}
    }
    setState(updatedState)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const errors = validate(state)
    if (_.keys(errors).length) {
      setState({...state, ...{errors}})
      return
    }
    const updatedState = {...state, ...{submitting: true}}
    setState(updatedState)
    try {
      await sendEmail(updatedState.email)
      navigate(`/c/auth/reset-password?email=${updatedState.email}`)
    } catch (e) {
      setState({...state, ...{submitting: false}})
    }
  }

  const {email, errors, submitting} = state
  const hasEmailError = _.keys(errors).some((k) => k.indexOf('send.email') > -1)
  const hasErrors = hasEmailError

  return (
    <Grid divided='vertically' centered doubling columns={2}>
      <Grid.Column width='6'>
        <Header as='h1'>Send Password Reset Code</Header>
        <Segment>
          <Form error={hasErrors} onSubmit={onSubmit}>
            <Form.Field error={hasEmailError} required>
              <label>Email</label>
              <Form.Input placeholder='Enter your Service Mocks email'
                          name='email'
                          value={email}
                          onChange={onInputChange}/>
            </Form.Field>
            <Message error>
              <Message.Content>
                <List bulleted>
                  {
                    _.keys(errors).map((key) => (
                      <List.Item key={key}>{errors[key]}</List.Item>
                    ))
                  }
                </List>
              </Message.Content>
            </Message>
            <Button.Group fluid widths={2}>
              <Button primary className='forgot-password-submit' loading={submitting}>Send Code</Button>
              <Button.Or/>
              <Button onClick={() => navigate('../login')}>Cancel</Button>
            </Button.Group>
          </Form>
        </Segment>
      </Grid.Column>
    </Grid>
  )
}

let ForgotPassword = (props) => {
  const {handleError} = props
  props = {...props, sendEmail: handleError(sendEmail)}
  return (<_ForgotPassword {...props}/>)
}

ForgotPassword = withHelmet(ForgotPassword, 'Forgot Password')
ForgotPassword = withErrorHandling(ForgotPassword)
ForgotPassword = memo(ForgotPassword)

export {ForgotPassword, _ForgotPassword, sendEmail}

export default ForgotPassword